import { render, staticRenderFns } from "./DeskEvent.vue?vue&type=template&id=ca47c1f0&scoped=true&"
import script from "./DeskEvent.vue?vue&type=script&lang=js&"
export * from "./DeskEvent.vue?vue&type=script&lang=js&"
import style0 from "./DeskEvent.vue?vue&type=style&index=0&id=ca47c1f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca47c1f0",
  null
  
)

export default component.exports